/**
 * Created by Jie Gao on 2019-05-20.
 */
export class DTReelEvents {
    public static readonly HIDE_REEL:string = "dtReelEvent_hideReel";
    // When the reel has started, send this event.
    public static readonly SHOW_REEL:string = "dtReelEvent_showReel";
}